import client from './http';

export default {
  async getActiveMember() {
    const response = await client.get('/api/restricted-customer/members/active-member');
    return response.data;
  },

  async getProducts() {
    const response = await client.get('/api/restricted-customer/products');
    return response.data;
  },
};
